import { useQuery } from "@tanstack/react-query";
import { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { getSensors } from "../../../../core/api/services/test.schedule.service";
import BreadcrumbComponent from "../../../../core/components/breadcrumb/breadcrumb.component";
import ContentHeader from "../../../../shared/content-header/content-header.component";
import TableSort from "../../../../shared/helpers/table-sort";
import { BreadCrumbInfoModel } from "../../../../shared/models/breadCrumbInfo.model";
import NewScheduleTableComponent from "./new-schedule-table.component";
import { useNavigate } from "react-router-dom";

const NewScheduleComponent = () => {
  const [PageNumber, setPageNum] = useState<number>(1);
  const [filters, setFilters] = useState<any>({});
  const pageSize = 10;
  const navigate = useNavigate();

  const navigateTo = (url: string) => {
    if (url) navigate(url);
  };

  const filter = useSelector((state: any) => {
    return state.test.scheduleFilter;
  });

  const [SortBy, setSortBy] = useState<any>("SensorId");
  const [SortDirection, setSortDirection] = useState<any>("desc");
  const [selectedTestType, setSelectedTestType] = useState<any>(null);

  const breadCrumbInfo: BreadCrumbInfoModel[] = [
    {
      label: "Test",
      active: false,
      onClick: () => navigateTo("/test"),
    },
    {
      label: "New Schedule",
      active: true,
    },
  ];

  const [columns, setColumns] = useState([
    {
      title: "Asset ID",
      label: "sensorId",
      width: "16rem",
      isSorted: true,
    },
    {
      title: "Display Name",
      label: "sensorDisplayName",
    },
    {
      title: "Address",
      label: "address",
    },
    {
      title: "Level",
      label: "level",
    },
  ]);

  useEffect(() => {
    setFilters(filter);
    setPageNum(1);
  }, [filter]);

  const {
    data: sensors,
    isLoading: isLoadingSensors,
    refetch,
  } = useQuery({
    queryKey: [
      "getSensors",
      PageNumber,
      filters?.townCouncil,
      filters?.site,
      filters?.block,
      filters?.testType ? filters?.testType : selectedTestType,
      SortBy,
      SortDirection,
    ],
    queryFn: ({ signal }) =>
      getSensors(
        PageNumber,
        pageSize,
        filters?.townCouncil,
        filters?.site,
        filters?.block,
        filters?.testType ? filters?.testType : selectedTestType,
        SortBy,
        SortDirection,
        signal
      ),
    enabled: Object.values(filter).some((value) => Boolean(value)),
  });

  const onRefetchData = () => {
    if (sensors?.numberOfRecords <= pageSize + 1) {
      setPageNum(1);
    }
    refetch();
  };

  const getTestType = (type: any) => {
    setSelectedTestType(type);
  };

  const handleChangePage = useCallback((page: number): void => {
    setPageNum(page);
  }, []);

  const handleChangeSort = useCallback(
    async (sortBy: string, sortDirection: any) => {
      if (!sortBy || !sortDirection) return;
      setSortBy(sortBy);
      setSortDirection(sortDirection);

      const copyColumns: any = await TableSort(columns, sortBy);
      setColumns(copyColumns);
    },
    []
  );

  return (
    <div>
      <div className="header-container">
        <div className="title-container">
          <ContentHeader
            pageTitle={breadCrumbInfo[breadCrumbInfo.length - 1]?.label}
          />
        </div>
      </div>

      <div className="page">
        <div className="page-container mt-4">
          <BreadcrumbComponent breadCrumbInfo={breadCrumbInfo} />
          <NewScheduleTableComponent
            columns={columns}
            data={sensors?.data}
            totalNumberOfRecords={sensors?.numberOfRecords}
            pageSize={pageSize}
            current={PageNumber}
            onChangePage={handleChangePage}
            onRefetchData={onRefetchData}
            onChangeSort={handleChangeSort}
            getTestType={getTestType}
            isLoading={isLoadingSensors}
          />
        </div>
      </div>
    </div>
  );
};

export default NewScheduleComponent;
